(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("yup"));
	else if(typeof define === 'function' && define.amd)
		define(["yup"], factory);
	else if(typeof exports === 'object')
		exports["YupSchema"] = factory(require("yup"));
	else
		root["YupSchema"] = factory(root["Yup"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 